import React, { useRef, useState } from 'react';
import Header from '../components/header';
import '../styles/help.css';
import { Phone, PlaceHolder } from '../constants';

const HelpPage = () => {
  const handleBackClick = () => {
    window.history.back(); // or use navigate(-1) if using react-router
  };

  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <div className="page-container">
      <Header title="Help" onBackClick={handleBackClick} />
      <div>
        <span className='howToRaise'>How to raise your Principal Certificate request?</span>

        {/* Video preview limited to 200px height until user plays; expands when playing */}
        <video
          ref={videoRef}
          className={`help-video ${isPlaying ? 'help-video--playing' : ''}`}
          poster={PlaceHolder}
          src="/PC_introduction.mp4"
          controls
          playsInline
          onPlay={() => setIsPlaying(true)}
          onPause={() => setIsPlaying(false)}
          onEnded={() => setIsPlaying(false)}
        />

        <div className="help-content">
          <h3 style={{
            color: '#012848',
            fontSize: 16,
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: '150%',
            letterSpacing: '0.15px'
          }}>Need Assistance in Completing Your Certificate request?</h3>
          <p style={{
            color: '#012848',
            fontSize: 14,
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '143%',
            letterSpacing: '0.17px'
          }}>
            Contact Bayer customer care for quick support and guidance through the process.
          </p>
          <button type="submit" className="call-button" >
            <img src={Phone} style={{ height: 20, width: 20, marginRight: 20 }} alt="" />
            Call 9418132222
          </button>
        </div>
      </div>

    </div>
  );
};

export default HelpPage;
